import { render } from "./ReusableDataDialog.vue?vue&type=template&id=01b13ce5"
import script from "./ReusableDataDialog.vue?vue&type=script&lang=js"
export * from "./ReusableDataDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__